import {NaeApiRest} from 'nae-react-rest'

class ApiRestService extends NaeApiRest {
   
}

const ApiRest = new ApiRestService();
export default ApiRest;
